import { Injectable } from '@angular/core';

import { SharedLanguageService, TranslateOrDefault } from '@language';
import { ApiFragment } from '@stylehaven/components';
import { BatchUserAction } from '../../entities/common/batch-user-action.entity';
import { BulkUserAction } from '../../entities/common/bulk-user-action.entity';
import { ActionDisabledCondition, UserAction } from '../../entities/common/user-action.entity';
import { GetCombinedEntityFromFragments } from '../fragments/combined-entity.helper';

@Injectable({ providedIn: 'root' })
export class ActionTooltipHelper {
    private BREAK = '\n';
    private prefix: string;

    constructor(public translateService: SharedLanguageService) {
        this.prefix = this.translateService.instant(`action-tooltips.error-prefix`);
    }

    public getActionTooltip(userAction: UserAction | BulkUserAction, records?: readonly ApiFragment[]): string {
        const disabledCondition: ActionDisabledCondition | undefined = userAction.getDisabledCondition();

        if (!disabledCondition) {
            return '';
        }

        let tooltipKey: string;
        const entitySpecificTooltip: boolean | undefined = disabledCondition.entitySpecificTooltip;

        if ((typeof entitySpecificTooltip !== 'undefined' && !entitySpecificTooltip) || !records) {
            tooltipKey = disabledCondition.tooltip;
        } else {
            const combinedEntity: string = GetCombinedEntityFromFragments(records);
            tooltipKey = `${disabledCondition.tooltip}.${combinedEntity}`;
        }

        const message: string =
            TranslateOrDefault(
                this.translateService,
                `action-tooltips.${tooltipKey}`,
                disabledCondition.tooltipFallback,
                {
                    amount: records?.length ?? 0,
                    ...(disabledCondition.tooltipOptions ?? {})
                }
            ) ?? '';

        return userAction instanceof UserAction ? `${this.prefix}${this.BREAK}${message}` : message;
    }

    public getBatchActionTooltip(userAction: BatchUserAction): string {
        const disabledCondition: ActionDisabledCondition | undefined = userAction.getDisabledCondition();

        if (!disabledCondition) {
            return '';
        }

        const tooltipKey: string = disabledCondition.tooltip;

        const message: string = this.translateService.instant(
            `action-tooltips.${tooltipKey}`,
            disabledCondition.tooltipOptions
        );

        return userAction instanceof UserAction ? `${this.prefix}${this.BREAK}${message}` : message;
    }
}
